import type { ProjectState, RefreshableProjectList } from "./project.types.ts"

// A load-more fired while a post-save re-read is out would take over the
// request id and drop the re-read, losing what the save changed.
export const refreshInFlight = (
  state: ProjectState,
  list: RefreshableProjectList
) => {
  const refreshId = state.listRefreshRequestIds[list]
  return !!refreshId && refreshId === state[`${list}RequestId`]
}

// The thunk `condition`: such a load-more is not sent at all.
export const skipLoadMoreDuringRefresh =
  (list: RefreshableProjectList) =>
  (
    { isMore }: { isMore: boolean },
    { getState }: { getState: () => unknown }
  ) => {
    const project = (getState() as { project?: ProjectState }).project
    return !(isMore && !!project && refreshInFlight(project, list))
  }
